import { useNavigate, useLocation } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';
import { getSettingsSubLabel } from './headerConstants';
import { useAuth, canAccessSettingsPath } from '@/auth/AuthContext';
import { useT } from '@/i18n/LanguageContext';

/** ホーム › 設定 › <current page> — only on /settings/* on desktop. */
export default function Breadcrumb() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useT();
  const inSettings = location.pathname.startsWith('/settings');
  const subKey = inSettings ? getSettingsSubLabel(location.pathname) : null;
  // Suppress the breadcrumb (which would leak the page name) when the user
  // is not allowed to view the current settings page.
  if (!inSettings || !subKey || !canAccessSettingsPath(user, location.pathname)) return null;
  return (
    <div className="hidden md:flex items-center gap-1.5 pb-3 -mt-1 text-[12px] text-zinc-500" data-testid="header-breadcrumb">
      <button type="button" onClick={() => navigate('/')} className="relative hover:text-zinc-700 transition-colors after:absolute after:-inset-2 after:content-['']">
        {t('common.home')}
      </button>
      <CaretRight size={10} weight="bold" className="text-zinc-300" />
      <button type="button" onClick={() => navigate('/settings/employees')} className="relative hover:text-zinc-700 transition-colors after:absolute after:-inset-2 after:content-['']">
        {t('common.settings')}
      </button>
      <CaretRight size={10} weight="bold" className="text-zinc-300" />
      <span className="text-zinc-900 font-semibold">{t(subKey)}</span>
    </div>
  );
}
